import * as types from './actionTypes';

export default () => (dispatch) => {
  dispatch({
    type: types.uiState.SAVE_PRODUCT_DESIGN_ALERT,
    payload: {
      saveProductDesignAlert: true,
    },
  });
};
